<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
    <div class="d-flex flex-row bd-highlight">
        <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
            <!-- <div class="list-group my-3">
                <li class="list-group-item list-group-item-action" disable>
                    <h2>Popular Business Category</h2>
                </li>
                <a class="list-group-item list-group-flush" 
                    (click)="routeToBusinessListPage(item.name)" routerLink=""
                    *ngFor="let item of popularItems | async; let i = index">                
                    <div class="media p-2">                        
                        <div class="media-body">
                            <h3 class="float-left">{{ item.name }}</h3>
                            <span class="float-right font-weight-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                                  </svg>
                            </span>
                        </div>
                    </div>                
                </a>     
            </div> -->

            <div class="list-group my-3">
                <li class="list-group-item list-group-item-action" disable>
                    <h2>All Business Category</h2>
                </li>
                
                <a class="list-group-item list-group-flush" 
                    (click)="routeToBusinessListPage(item.name)" routerLink=""                     
                    *ngFor="let item of itemsArray; let i = index">               
                    <div class="media p-2">
                        <div class="media-body">
                            <h3 class="float-left">{{ item.name }}</h3>
                            <span class="float-right font-weight-bold">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                                  </svg>
                            </span>
                        </div>
                    </div>                
                </a> 
                
                
                <div class="search-results"
                    infiniteScroll
                    [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="50"
                    (scrolled)="nextList()">
                </div>    
                <app-loading-spinner  *ngIf="loading"></app-loading-spinner>
            </div>
        </div>
    </div>
</div>